import { Component, OnInit, forwardRef, HostBinding, Input, OnChanges, SimpleChanges, ViewChild, HostListener, ElementRef, Output, EventEmitter, ChangeDetectorRef, Self, Optional, AfterViewInit } from '@angular/core';
import { query } from '@angular/core/src/render3/instructions';
import { AbstractControl, ControlValueAccessor, FormControl, FormGroup, NgControl, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidatorFn, Validators } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operator/map';
import { filter, switchMap } from 'rxjs/operators';
import { NgbTypeahead } from '@ng-bootstrap/ng-bootstrap';
import { QuestionnaireService } from '../services/questionnaire.service';

export interface ArrayData {
  name?: string;
  mtext?: string;
}

@Component({
  selector: 'app-dplist-new',
  templateUrl: './dplistNew.component.html',
  styleUrls: ['./dplistNew.component.scss'],
  // providers: [
  //   {
  //     provide: NG_VALUE_ACCESSOR,
  //     useExisting: forwardRef(() => DplistComponentNew),
  //     multi: true
  //   }
  //   // ,
  //   // {
  //   // 	provide: NG_VALIDATORS,
  //   // 	useExisting: forwardRef(() => DplistComponentNew),
  //   // 	multi: true,
  //   // }
  // ]
})
export class DplistComponentNew implements OnInit, ControlValueAccessor {
  @Input() aData: Observable<ArrayData[]>;
  @Input() searchResult: Observable<ArrayData[]>;
  @Input() searchQuery: Observable<string>;
  @Input() valueArr: ArrayData[];
  @Input() isDisabled: boolean = false;
  @Input() atrrAriaLabel: string;
  @Input() atrrDropDownId: string;
  @Input() asyncData: boolean;
  control: AbstractControl;
  submitted: boolean = false;
  @ViewChild('selectElement') selectElement: HTMLSelectElement;
  @Output() public change: EventEmitter<string> = new EventEmitter<string>();
  @Output() public blur: EventEmitter<string> = new EventEmitter<string>();
  @Output() public onSelectItem: EventEmitter<string> = new EventEmitter<string>();
  @Output() public onToggleItems: EventEmitter<string> = new EventEmitter<string>();
  listHidden: boolean = true;
  isSelected: boolean = false;
  public inputControl = new FormControl('', this.validators);
  toggleHasRun: boolean = true;
  isFocused: boolean = false;

  shadowedList: Array<string> = [];
  shadowedListIndex: number = 0;

  markRed: boolean = false;
  constructor(@Self() @Optional() public ngControl: NgControl,
    private eRef: ElementRef, private _changeDetector: ChangeDetectorRef, private questionnaireService: QuestionnaireService) {

    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  ngOnInit(): void {
    this.errors;
    this.inputControl.invalid;
    this.inputControl.markAsUntouched();
    this.inputControl.updateValueAndValidity();

    this.questionnaireService.submitted$.subscribe(isSubmitted => {
      if (isSubmitted && !this.isSelected && !this.isDisabled) {
        this.markRed = true;
        this.control.markAsTouched();
        if (!this._changeDetector['destroyed']) {
          this._changeDetector.detectChanges();
        }
      }
      else {
        this.submitted = false;
        this.markRed = false;
        this.inputControl.markAsUntouched();
      }

    })

    if (this.aData && this.asyncData) {
      this.aData.subscribe(res => {
        if (res) {
          this.shadowedList = res.map(el => el.name);
          this.shadowedListIndex = this.shadowedList.indexOf(this.val);
          // console.log('adata async', this.shadowedList, this.val, this.shadowedListIndex);
        }
      })
    } else {
      if (this.valueArr) {
        this.shadowedList = (this.valueArr as Array<string>).map(el => el);
        this.shadowedListIndex = this.shadowedList.indexOf(this.val);
        // console.log('adata sync', this.shadowedList, this.val, this.shadowedListIndex);
      }
    }
  }

  onChange: any = () => { }

  onTouch: any = () => { }

  val = '';

  set value(val) {
    if (val !== undefined && this.val !== val) {
      this.setValue(val);
    }
  }

  get errors() {
    const control = this.ngControl && this.ngControl.control

    if (control) {
      this.control = control;
      return control.touched && control.errors;
    }
    return null;
  }
  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    // this.filterArray();
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState?(isDisabled: boolean): void {

  }

  onSelect(item: any) {
    this.selectNewItem(item);
    this.listHidden = true;
    this.onSelectItem.emit();
  }

  selectNewItem(item: any) {
    this.listHidden = true;

    if (item !== 'בחר') {
      this.inputControl.markAsTouched();
      this.inputControl.markAsDirty();
      this.inputControl.updateValueAndValidity();
      this.markRed = false;
      this.isSelected = true;
    }
    this.setValue(item);
    this.change.emit(item);
  }

  private setValue(item: string) {
    this.val = item;
    this.onChange(item);
    this.onTouch(item);
  }

  toggleItems() {
    // console.log('toggleItems', this.atrrAriaLabel);
    if (!this.isDisabled) {
      this.listHidden = !this.listHidden;
    }
    if (!this.listHidden && !this.isSelected) {
      this.inputControl.markAsTouched();
      this.inputControl.markAsDirty();
      this.inputControl.updateValueAndValidity();
      this.markRed = true;
    }
    if (this.isSelected)
      this.markRed = false;

    this.toggleHasRun = true;
    this.onToggleItems.emit();
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    // console.log('clickout', this.atrrAriaLabel);
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.listHidden = true;
    }
  }

  @HostListener('document:keydown', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (this.isFocused) {
      if (event.key === 'ArrowUp' || event.key === 'ArrowDown' || event.key === 'Enter') {
        if (event.key === 'ArrowUp') {
          this.shadowedListIndex--;
          if (this.shadowedListIndex < 0) {
            this.shadowedListIndex = this.shadowedList.length - 1;
          }
        } else if (event.key === 'ArrowDown') {
          this.shadowedListIndex++;
          if (this.shadowedListIndex >= this.shadowedList.length) {
            this.shadowedListIndex = 0;
          }
        } else if (event.key === 'Enter') {
          this.selectNewItem(this.shadowedList[this.shadowedListIndex]);
        }
        // console.log('shadowedListIndex', this.shadowedListIndex);
        event.preventDefault();
      } else if (event.key === 'Tab') {
        // console.log('key event', this.atrrAriaLabel);
        this.listHidden = true;
      }

    }
  }

  private get validators(): ValidatorFn[] {
    return [Validators.required]
  }

  handleClick() {
    if (this.toggleHasRun === false) {
      this.toggleItems();
    }

  }

  myFocus(evt: Event) {
    this.toggleHasRun = true;
    this.isFocused = true;
    this.toggleItems();
  }

  myBlur(evt: Event) {
    this.isFocused = false;
    this.blur.emit(this.val);
  }
}



// WEBPACK FOOTER //
// ./src/app/dpListNew/dplistNew.component.ts